import styled from 'styled-components';
import { ClutchLogo, StarFilled } from '../../../../assets/svg';
import { COLORS, device, FONTS } from '../../../../constants';
import { Spacer } from '../../../Spacer/Spacer';
import { PrivacyPolicyAndTermsLinks } from './PrivacyPolicyAndTermsLinks';

export const Reviewed = () => (
  <ReviewedContainer>
    <ReviewedHeader>
      <ReviewedTitle>REVIEWED ON</ReviewedTitle>
      <LogoWrapper>
        <ClutchLogo />
        <StarsWrapper>
          <Stars>
            <StarFilled />
            <StarFilled />
            <StarFilled />
            <StarFilled />
            <StarFilled />
          </Stars>
          <Spacer height={10} />
          <ReviewsCount>71 REVIEWS</ReviewsCount>
        </StarsWrapper>
      </LogoWrapper>
    </ReviewedHeader>
    <PrivacyPolicyAndTermsLinks />
  </ReviewedContainer>
);
const ReviewedContainer = styled.div`
  @media screen and ${device.md} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media screen and ${device.sm} {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
`;
const ReviewedHeader = styled.div``;
const ReviewedTitle = styled.div`
  color: ${COLORS.WHITE};
  font-size: 13px;
  line-height: 18px;
  font-weight: 300;
  font-family: ${FONTS.SUBTITLE};
  margin-bottom: -5px;
  text-align: left;
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 40px;
  @media screen and ${device.md} {
    margin: 0;
    align-items: center;
  }
`;

const StarsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Stars = styled.div`
  display: flex;
  gap: 4px;
`;

const ReviewsCount = styled.span`
  color: ${COLORS.WHITE};
  font-weight: 400;
  font-size: 14px;
  line-height: 16.8px;
  font-family: 'Manrope';
`;
